import {PageView} from "./PageView.js";
import {Header} from "../components/Header.js";
import {CompanyNameInput} from "../components/input/CompanyNameInput.js";
import {CompanyCategorySelect} from "../components/select/CompanyCategorySelect.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {CompanyProfileLayout} from "../components/layout/CompanyProfileLayout.js";
import {
    addCompanyCategory,
    addCompanyName,
    addCompanySubDomain, addHopeCount, addServiceType,
    collectGtm,
    getUser,
    isSnsSignUp,
    isWebView
} from "../store.js";
import {DEFAULT_SUB_DOMAIN, ERROR_CODE} from "../constant.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import {mobileSignIn} from "../../../bridge/renewal-signup/index.js";
import {HopeUserCountSelect} from "../components/select/HopeUserCountSelect.js";


export class CompanyProfileView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;

        new CompanyProfileLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            nextButton: {
                text: `${i18next.t(login.registerComplete)}`,
                nextPageFunc: this.createCompany.bind(this)
            } ,
            nextLink : {
                text : i18next.t(login.existingTeam),
                nextPageFunc: () => {
                    SignUpViewChanger.loadSearchCompanyBySubDomain();
                }
            }
        });
    }


    getSectionId() {
        return `companyInfoInputSection`
    }

    renderComponents() {
        const $section = $(`#${this.getSectionId()}`)

        new Header($section.find('.js-section-header'), {
            isShowLoginBtn: false,
            isShowPrevBtn: true,
        })

        this.$props.CompanyNameInput = new CompanyNameInput($section.find('#companyNameLayer'), {
            addClassName: this.getCommonJoinInputClassName(),
            submit : this.createCompany.bind(this),
        })

        this.$props.CompanyCategorySelect = new CompanyCategorySelect($section.find('#companyCategorySelectLayer'), {
            addClassName: this.getCommonJoinInputClassName()
        });


        this.$props.CompanyHopeUserConutSelect = new HopeUserCountSelect($section.find('#hopeCountSelectLayer') , {
            addClassName: this.getCommonJoinInputClassName(),
            isLast: true,
        });

    }

    addCompanyInfo() {
        addCompanyName(this.$props.CompanyNameInput.getInputValue())
        addCompanySubDomain(this.getSubDomain())
        addCompanyCategory(this.$props.CompanyCategorySelect.getSelectValue())
        addHopeCount(this.$props.CompanyHopeUserConutSelect.getSelectValue());
        addServiceType(this.getServiceType());
    }

    getSubDomain() {
        const companyName = this.$props?.CompanyNameInput?.getInputValue();
        if (Mutil.empty(companyName)) {
            return;
        }
        const isValidCompanyUrl = InputValidator.isValidTeamUrl(companyName);
        return isValidCompanyUrl ? companyName : DEFAULT_SUB_DOMAIN;
    }
    getServiceType() {
        return Mutil.n2v($(".js-service-type-layer:visible input[name=radioOption]:checked").val(), "");
    }
    getCommonJoinInputClassName() {
        return `js-join-input`
    }
    async createCompany() {
        const $section = $(`#${this.getSectionId()}`);
        const $Inputs = $section.find(`.${this.getCommonJoinInputClassName()}`);
        if (!InputValidator.inputsValidate($Inputs)) {
            return;
        }

        const loadingPopup = new LoadingPopup($section.find("article"), {
            isAppend: true,
            loadingText : i18next.t(login.createWorkSpace)
        });

        this.addCompanyInfo();
        const {ERR_CD = '', ERR_MSG = '', PASS_JSON = {}, COMPANY_INFO_JSON = {}, SUB_DOM = ''} = await getUser().createNewCompany();
        if(ERR_CD === ERROR_CODE.BLOCK_DOMAIN) {
            Mutil.toast("error", i18next.t(exception.error.limitEmail))
            loadingPopup.removePopup();
            return;
        }

        if (ERR_CD === ERROR_CODE.EXIST_SUB_DOMAIN) {
            Mutil.mlog("서브도메인이 존재합니다.");
            loadingPopup.removePopup();
            return;
        }

        if (ERR_CD === ERROR_CODE.EXIST_COMPANY) {
            Mutil.mlog("이미 회사가 존재합니다.");
            loadingPopup.removePopup();
            return;
        }

        if (ERR_CD === ERROR_CODE.VERIFICATION_FORGED) {
            Mutil.mlog("인증번호 검증결과가 변조되었을 수 있습니다.")
            loadingPopup.removePopup()

            Mutil.toast('error', ERR_MSG)
            setTimeout(() => {
                location.reload()
            }, 2000)
            return
        }

        if(window?.isFuncPhoneGetPop) {
            this.signIn({...PASS_JSON});
            return
        }

        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin({...PASS_JSON}, () => {
            loadingPopup.removePopup();
            SignUpViewChanger.loadInviteUserView({...COMPANY_INFO_JSON, SUB_DOM_DATA: SUB_DOM, isSignUpBySnS : isSnsSignUp() });
        });
    }

    signIn(PASS_JSON = {}) {
        if (isWebView()) {
            mobileSignIn({...getUser().getCreateNewCompanyInfoJson()});
            return;
        }
        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin({...PASS_JSON}, () => {
            CommonLogin.moveMainPage({
                firstLoginYn: 'Y',
                desktopGuideYn: 'Y',
            });
        });
    }
}
